import EnterpriseIcon, { InfoIcon } from '@enterprise-ui/icons';
import React__default from 'react';
import Tooltip from '../../Tooltip.js';

var TooltipHeader = function TooltipHeader(_ref) {
  var columnTextId = _ref.columnTextId,
    headerText = _ref.headerText,
    tooltipText = _ref.tooltipText;
  var text = /*#__PURE__*/React__default.createElement("span", {
    className: "C-HeaderCell__text",
    id: columnTextId
  }, headerText);
  if (tooltipText) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "C-HeaderCell__tooltipHeader"
    }, text, /*#__PURE__*/React__default.createElement(Tooltip, {
      "data-testid": "header-tooltip",
      content: tooltipText,
      location: "bottom"
    }, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
      icon: InfoIcon,
      className: "C-HeaderCell__tooltipIcon"
    })));
  }
  return text;
};

export { TooltipHeader as default };
